window.addEventListener('DOMContentLoaded', () => {
	let video = document.getElementById('video')
	let plyBtn = document.getElementById('vidBtn')
	let vidWrapper = document.getElementById('playVid')

	function videoPausePlayHandler(e) {
		if (e.type == 'playing') {
			video.setAttribute('controls', 'controls')
			plyBtn.style.display = 'none'
			vidWrapper.classList.toggle('paused')
		} else if (e.type == 'pause') {
			video.removeAttribute('controls')
			plyBtn.style.display = 'block'
			vidWrapper.classList.toggle('paused')
		}
	}

	if (vidWrapper && video) {
		vidWrapper.onclick = function () {
			video.play()
		}

		video.addEventListener('playing', videoPausePlayHandler, false)
		video.addEventListener('pause', videoPausePlayHandler, false)
	}
})

window.addEventListener('DOMContentLoaded', () => {
	// This is specifically for the service pages video blocks
	const videos = document.querySelectorAll(
		'section.video video, section.cards .card .video video'
	)
	videos.forEach(video => {
		let vidWrapper = video.closest('.playVid')
		let plyBtn = vidWrapper?.querySelector('.video-play')

		function videoPausePlayHandler(e) {
			if (e.type == 'playing') {
				video.setAttribute('controls', 'controls')
				plyBtn.style.display = 'none'
				vidWrapper.classList.toggle('paused')
			} else if (e.type == 'pause') {
				video.removeAttribute('controls')
				plyBtn.style.display = 'block'
				vidWrapper.classList.toggle('paused')
			}
		}

		if (vidWrapper && video) {
			vidWrapper.onclick = function () {
				video.play()
			}

			video.addEventListener('playing', videoPausePlayHandler, false)
			video.addEventListener('pause', videoPausePlayHandler, false)
		}
	})
})
